import { Message } from "../types/MessageListType";

type MediaSrcFields = {
  media_url?: string | null;
  message_content?: string | null;
  caption?: string | null;
};

export function looksLikeMediaPathOrUrl(value: string): boolean {
  const s = String(value || "").trim();
  if (!s) return false;
  if (/^https?:\/\//i.test(s)) return true;
  if (s.startsWith("uploads/") || s.startsWith("lyke/")) return true;
  if (/\.(webp|jpe?g|png|gif|mp4|mov|webm|m3u8)(\?|$)/i.test(s)) return true;
  if (/\.(pdf|docx?|xlsx?|pptx?|zip|rar|7z|txt|csv|json)(\?|$)/i.test(s)) {
    return true;
  }
  return false;
}

/** Prefer media_url; legacy fallback if message_content still looks like a file URL. */
export function resolveMediaSrc(msg: MediaSrcFields | Partial<Message> | null | undefined): string {
  if (!msg) return "";
  const mediaUrl = String(msg.media_url || "").trim();
  if (mediaUrl) return mediaUrl.replace(/\\/g, "/");

  const content = String(msg.message_content || "").trim();
  if (looksLikeMediaPathOrUrl(content)) return content.replace(/\\/g, "/");
  return "";
}

/** Caption under media (empty for legacy URL-only rows). */
export function resolveMediaCaption(msg: MediaSrcFields | Partial<Message> | null | undefined): string {
  if (!msg) return "";
  const captionField = String(msg.caption ?? "").trim();
  if (captionField && !looksLikeMediaPathOrUrl(captionField)) return captionField;

  const content = String(msg.message_content || "").trim();
  if (!content || looksLikeMediaPathOrUrl(content)) return "";
  // Normalized shape: media_url set → message_content is caption (never a file URL)
  return content;
}
